export const WebViewMessageEventKeys = {
  royaltySection: 'royaltySection',
  redeemDiscountCode: 'redeemDiscountCode',
  addFastProductToCart: 'addFastProductToCart',
  viewBlog: 'viewBlog'
}